<template>
  <div>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/hotels/store"
      >{{ $t("customers.hotelsN.newHotel") }}</v-btn
    >
    <DataTable
      ref="hotelDataTable"
      :url="api.ACTIONS.HOTEL"
      :titles="titles"
      :fields-hidden-add="['created_at', 'updated_at']"
      :title="$t('customers.hotelsN.title')"
      :enableEdit="false"
      :enableAdd="false"
      :enableDelete="false"
      :add-rules="rules"
      :actions-extra-main="actionsExtraMain"
    />
  </div>
</template>

<style>
.hbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import i18n from "@/i18n";

const required = (val) =>
  (val !== null && val !== undefined) || i18n.t("customers.hotelsN.requiredField");

export default {
  name: "Hotels",
  title() {
    return this.$t("customers.hotelsN.title");
  },
  components: { DataTable },
  data() {
    return {};
  },

  computed: {
    rules() {
      return {
        name: [required],
      };
    },
    titles() {
      return {
        id: this.$t("customers.hotelsN.id"),
        name: this.$t("customers.hotelsN.name"),
        address: this.$t("customers.hotelsN.address"),
        landmark: this.$t("customers.hotelsN.landmark"),
      };
    },
    actionsExtraMain() {
      return {
        editHotel: {
          title: this.$t("customers.hotelsN.editHotel"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "EditHotel",
              params: { id: item.id },
            }),
        },
        deleteHotel: {
          title: this.$t("customers.hotelsN.deleteHotel"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.loading = true;
            this.axios
              .delete(`hotel/${id}`)
              .then((res) => {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("customers.hotelsN.deleted"),
                  "green"
                );
                this.$refs.hotelDataTable.getData();
              })
              .catch((err) => {
                let response = err.response;
                if (response) {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    response.data.message,
                    "red"
                  );
                } else {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    this.$t("customers.hotelsN.somethingWentWrong"),
                    "red"
                  );
                }
              })
              .finally(() => (this.loading = false));
          },
        },
      };
    },
  },
};
</script>
